import { __DEV__ } from "@/models/serverClient";
import { getPlatform, isNativeApp } from "@/models/platform";
import { version } from "../../package.json";
import * as serverClient from "@/models/serverClient";
import { datadogLogs } from "@datadog/browser-logs";
import { useUserSlice } from "@/models/useUserSlice";
import { useAuth } from "@/models/useAuth";
import { useUISlice } from "@/models/useUISlice";
import { getLocale } from "@/models/utils";

if (typeof window !== "undefined" && !__DEV__) {
  const env = "prod";
  const isNative = isNativeApp();

  datadogLogs.init({
    clientToken: import.meta.env.VITE_PUBLIC_DATADOG_CLIENT_TOKEN,
    site: "datadoghq.com",
    forwardErrorsToLogs: true,
    service: isNative ? "purelynovels-native" : "purelynovels-web",
    env,
    version,
    sessionSampleRate: 100,
  });

  // Defer store access to avoid circular dependency during module initialization
  queueMicrotask(() => {
    const userToken = useUserSlice?.getState()?.userToken;

    if (userToken) {
      const user = serverClient.parseJwt(userToken);
      datadogLogs.setUser({
        id: user.userId,
        email: user.email,
        country: user.country,
        ip: user.ip,
      });
    }
  });
}

export type FunnelEvent =
  | "[1] app:loaded"
  | "[2] auth:signed_in_as_guest"
  | "[3] auth:signed_in"
  | "[4] onboarding:started"
  | "[5] onboarding:completed"
  | "[6] home:loaded"
  | "[7] home:book_tapped"
  | "[8] reader:chapter_opened"
  | "[9] reader:chapter_generated"
  | "[10] paywall:viewed"
  | "[11] paywall:purchase_completed"
  | "[F1] funnel:quiz_started"
  | "[F2] funnel:quiz_completed"
  | "[F3] funnel:paywall_viewed"
  | "[F4] funnel:checkout_started"
  | "[F5] funnel:purchase_complete"
  | "[4a] onboarding:quiz_started"
  | "[4b] onboarding:quiz_completed"
  | "[4c] onboarding:paywall_viewed"
  | "[4d] onboarding:paywall_skipped"
  | "[4e] onboarding:rated"
  | "[4f] onboarding:countdown_expired"
  | "notification:prompted"
  | "notification:accepted"
  | "notification:denied"
  | "share:book_shared"
  | "share:book_opened";

export const logFunnelEvent = (
  funnel: FunnelEvent,
  data?: { [key: string]: any }
) => {
  try {
    const user = useAuth.currentAuthUser();

    datadogLogs?.logger?.info(`[Funnel]${funnel}`, {
      funnelData: {
        platform: getPlatform(),
        isMobile: useUISlice?.getState()?.device?.isMobile,
        userId: user?.userId,
        email: user?.email,
        country: user?.country,
        ip: user?.ip,
        language: getLocale(),
        version,
      },
      funnelEventData: data || {},
    });
  } catch (error) {}
};
